import React, { FC } from 'react';
import { Paper, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Sources from './Sources';
import theme from 'theme';

const styles = {
  paper: {
    padding: theme.spacing(2, 3, 3.5, 2),
  },
} as const;

const GroupSources: FC = () => {
  const { t } = useTranslation();

  return (
    <Paper sx={styles.paper}>
      <Grid container paddingTop={2} paddingLeft={2} spacing={3}>
        <Grid xs={12} sm={3}>
          <Typography variant="subtitle2" marginRight={1}>
            {t('groups:sources')}
          </Typography>
        </Grid>

        <Grid xs>
          <Sources />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default GroupSources;
